exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.popup.visible{background-color:#fff;padding:.3em .75em;text-transform:uppercase;font-size:12px;letter-spacing:.5px;font-weight:600;border:0;box-shadow:0;border-radius:.1}.ui.popup.visible [data-tooltip]:before{box-shadow:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/Popup/index.scss
// module id = 1021
// module chunks = 0